import React from 'react';
import styles from './betslip-banner.module.scss';
import Image from 'next/image';
import { mavenPro } from '@/lib/fonts';
import { useTranslations } from 'next-intl';
import { useBetslipContext } from '@/features/betslip/contexts/betslip-context';
import clsx from 'clsx';
import { TICKET_STATES, useGoldenDuelTicketEligibility } from '@/hooks/golden-duel';

interface BetslipBannerProps {
	showAnimated?: boolean;
	size?: 'sm' | 'lg';
	ticket: {
		LeagueId: number;
		stake: number;
	};
}


const getBannerText = (state: typeof TICKET_STATES[keyof typeof TICKET_STATES], t: any, awayCount: number, targetAmount: number, currencyName: string) => {
	const formattedAmount = `${currencyName} ${targetAmount}`;
	switch (state) {
		case TICKET_STATES.NO_STAKE:
			return t.raw('lbl_AmountNo').replace('{currency}', currencyName).replace('{x}', targetAmount);
		case TICKET_STATES.AWAY_COUNT:
			return t.raw('lbl_AmountShort').replace('{currency}', currencyName).replace('{x}', awayCount);
		case TICKET_STATES.REACHED:
			return t('lbl_AmountReached');
		case TICKET_STATES.NO_AMOUNT:
			return t.raw('lbl_AmountNo').replace('{x}', formattedAmount);
		default:
			return '';
	}
};

export const BetslipBanner = ({ 
	size = 'sm', 
	ticket
}: BetslipBannerProps) => {
	const t = useTranslations('General');
	const { currencyName } = useBetslipContext();
	const { isEligible, awayCount, targetAmount, ticketState } = useGoldenDuelTicketEligibility(ticket);

	const bannerText = getBannerText(ticketState, t, awayCount, targetAmount, currencyName);

	return isEligible?(
		<div className={clsx(styles.container, 'banner-container')} data-size={size}>
			{ticketState === TICKET_STATES.REACHED ? (
				<NbaTicket />
			) : (
				<Image
					src={'/images/promotion/golden-duel/my-tickets/ac-nba.svg'}
					alt={'Active Ticket'}
					width={26.7}
					height={16.7}
				/>
			)}
			<div className={`${styles.title} ${mavenPro.className}`}>
				{bannerText}
			</div>
		</div>
	): null;
};

const NbaTicket = () => (
	<div className={styles.iconWrapper}>
		<div className={styles.acNba}>
			<Image
				src={'/images/promotion/golden-duel/my-tickets/ac-nba.svg'}
				alt={'Active Ticket'}
				fill
			/>
		</div>
		<div className={styles.shine}>
			<Image
				src={'/images/promotion/golden-duel/shine.svg'}
				alt={'Shine'}
				fill
			/>
		</div>
		<div className={styles.greenCheck}>
			<Image
				src={'/images/promotion/golden-duel/green-check.svg'}
				alt={'Green Check'}
				fill
			/>
		</div>
	</div>
);
